<script lang="ts">
  import { currentTheme } from "app/stores/userPreferences";
  import { Theme, type ThemeDetails } from "app/models/shared-types";
  import { browser } from "$app/environment";

  const THEMES: { [key in Theme]: ThemeDetails } = {
    [Theme.Light]: {
      label: "light",
      color: "#FFFFFF",
      scrollbarColor: "#D2D4D9",
    },
    [Theme.Dark]: {
      label: "dark",
      color: "#000000",
      scrollbarColor: "#505256",
    },
  } as const;

  // updates theme post-hydration
  $: if (browser) {
    if ($currentTheme === Theme.Dark) {
      document.documentElement.classList.remove(Theme.Light);
      document.documentElement.classList.add($currentTheme);
    } else {
      document.documentElement.classList.remove(Theme.Dark);
    }

    // the theme-color value for the name attribute of the <meta> element indicates a suggested color
    // that user agents should use to customize the display of the page or of the surrounding user interface.
    document
      .querySelector("meta[name='theme-color']")
      ?.setAttribute("content", THEMES[$currentTheme]?.color);
    // sets scrollbar color according to the theme selected
    document.documentElement.style.setProperty(
      "--scrollbar-color",
      THEMES[$currentTheme]?.scrollbarColor
    );
  }
</script>
